import React, { useContext, useState } from "react";
import { Pagination } from "antd";
import { Icon } from "@iconify/react";
import GetHistoryData from "../../../hooks/GetHistory";
import { useParams } from "react-router-dom";
import axios from "axios";
import { tableDataContext } from "../../context/productData";

const Analyzedpdf = (props) => {
  const { heading, hide, setDbdatapdf, setShow, setVen_name, dbdatapdf } =
    props;
  const [current, setCurrent] = useState(1);
  const { history, loading } = GetHistoryData();
  const { setAllResponse, setPdfData } = useContext(tableDataContext);

  const { id } = useParams();

  const onChange = (page) => {
    console.log(page);
    setCurrent(page);
  };


  const HandleHistorypdf = (pdf, vendor) => {
    console.log(pdf, vendor);
    setPdfData("");
    setAllResponse([])
    axios
      .post(
        "https://aipricingtool-python.onrender.com/search_output_by_pdf_name",
        {
          vendor_name: vendor,
          pdf_name: pdf,
          user_identifier: id,
        }
      )
      .then((res) => {
        if (res.data.output_data.length > 0) {
          const outputs = res.data.output_data.map(
            (item) => item.output.output
          );
          const vendorName = res.data.output_data[0].vendor_name;
          const pdfName = res.data.output_data[0].pdf_name;
          localStorage.setItem("pdf_name", pdfName);
          setPdfData({ dbPdfData: outputs, venName: vendorName });
          setVen_name(vendorName);
          setDbdatapdf(outputs);
          setShow(true);
        } else {
          return;
        }
      });
  };

  return (
    <>
      <div className="flex flex-col items-center w-full mb-4">
        <span className=" text-xl md:text-3xl mb-2 font-semibold mr-5 primary text-center">
          {heading}
        </span>

        <div className="setting pagination w-full  py-5 px-3  flex flex-col  justify-between  ">
          <div>
            {history !== "" ? (
              <>
                {history?.map((history, index) => {
                  console.log(history);
                  return (
                    <div
                      key={index}
                      className="flex space-x-2  cursor-pointer"
                      onClick={() => {
                        HandleHistorypdf(
                          history?.pdf_name,
                          history?.vendor_name
                        );
                      }}
                    >
                      <div className="flex items-center">
                        <Icon icon="lucide:file" width={20} height={20} />
                      </div>
                      <div
                        className={`overflow-hidden ${
                          history?.pdf_name?.length > 20 ? "truncate" : ""
                        }`}
                      >
                        {history.pdf_name}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="flex justify-center items-center h-24 text-xl font-bold primary">
                No History Yet
              </div>
            )}
          </div>
          <div className={`flex items-center w-100 justify-center ${hide}`}>
            <Pagination current={current} onChange={onChange} total={50} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Analyzedpdf;
